import styled from 'styled-components'
import Link from 'next/link'
import Image from 'next/legacy/image'
import ContentRenderer from 'content-renderer'
import { Typography } from 'common/typography'
import Wrapper from 'common/wrapper'
import { SecondaryButton, NeutralButtonOutline } from 'common/button'
import calcProgressAngle from 'utils/calc-progress-angle'
import { COMPLETED, INPROGRESS } from 'utils/project-status'
import useSession from 'querys/session'
import LearningBadgePath from './lessons-path/learning-badge-path'
import ProjectStepStatus from './final-project-status'

const FinalProjectStyled = styled.section`
  padding-bottom: 80px;
  .final-project {
    display: flex;
    &-description {
      font: var(--regular);
    }
  }
  .final-path {
    min-width: 36px;
    margin-right: 16px;
    position: relative;
    display: flex;
    align-items: center;
    &::before {
      position: absolute;
      margin: 0 auto;
      right: 0;
      top: -50px;
      bottom: 50%;
      left: 0;
      width: 2px;
      content: '';
      background: var(--white);
    }
    &.final-workshop::before {
      display: none;
    }
  }
  h2 {
    margin: 16px 0;
  }
  .certificate {
    margin-block-start: 1rem;
  }
  @media(min-width: 768px) {
    padding: 48px 0 80px;
    .certificate {
      margin-block-start: 0;
      margin-inline-start: 1rem;
    }
    .final-path {
      align-items: flex-start;
      padding-top: 12px;
      min-width: 64px;
      margin-right: 38px;
      &::before {
        width: 4px;
        bottom: calc(100% - 48px);
      }
    }
  }
  @media(min-width: 1024px) {
    .final-project {
      &-content {
        gap: 16px;
        display: flex;
        flex-direction: row-reverse;
      }
      &-description {
        font: var(--regular);
        flex: 1;
      }
      &-img {
        position: relative;
        flex: 1;
      }
    }
  }
`

function FinalProject({
  project, badge, course_progress, isWorkShop, certificate,
}) {
  const { token } = useSession()

  if (!project || !badge) return null

  const { name, image } = badge

  const {
    cover_image, title, slug, progress_status, description,
  } = project

  const courseCompleted = course_progress === 100
  const inProgress = progress_status?.status === INPROGRESS
  const completed = progress_status?.status === COMPLETED
  let progress = 0
  if (courseCompleted) {
    progress = 50
  }
  if (completed) {
    progress = 100
  }

  return (
    <FinalProjectStyled role="region" aria-label="Projecto final del curso">
      <Wrapper maxWidth="1200">
        <div className="final-project">
          <div className={isWorkShop ? 'final-workshop final-path' : 'final-path'}>
            <LearningBadgePath src={image} alt={name} progress={progress} progressAngle={calcProgressAngle(progress)} />
          </div>
          <div className="final-project-content">
            <div className="final-project-img">
              <Image
                width={600}
                height={450}
                objectFit="cover"
                src={cover_image}
                alt={`Miniatura del proyecto ${title}`}
              />
            </div>
            <div className="final-project-description">
              <Typography small="headline4" large="headline3" as="h2" color="var(--sky-inverted)">
                {title}
              </Typography>
              <ContentRenderer chunks={description.blocks} color="var(--textOpaque)" />
              <ProjectStepStatus slug={slug} projectStatus={progress_status} />
              <div className="btn-container">
                {inProgress ? (
                  <Link href={`/estudiante#${slug}`}>
                    <SecondaryButton fitContent fullWidth>
                      Solicitar Revisión
                    </SecondaryButton>
                  </Link>
                ) : (
                  <Link href={`/proyectos/${slug}`}>
                    <SecondaryButton fitContent fullWidth disabled={!token}>
                      Ver proyecto
                    </SecondaryButton>
                  </Link>
                )}
                {certificate?.uuid ? (
                  <Link href={`/certificados/${certificate.uuid}`} passHref>
                    <NeutralButtonOutline height="48" fullWidth fitContent className="certificate">
                      Ver certificado
                    </NeutralButtonOutline>
                  </Link>
                ) : (
                  <NeutralButtonOutline height="48" fullWidth fitContent className="certificate" disabled>
                    Ver certificado
                  </NeutralButtonOutline>
                )}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </FinalProjectStyled>
  )
}

export default FinalProject
